import React, { useCallback } from 'react'

import { Dropdown } from '@sketch/components'
import {
  useSortingSettings,
  SortBy,
  SortOrder,
  useSetSortingSettings,
} from '../../hooks/useSortSettings'

import {
  ArrowContainerTooltip,
  ArrowDownIcon,
  ArrowUpIcon,
  StyledDropdownItem,
} from './SortDropdown.styles'
import {
  SortOptions,
  useSortOptionsSettings,
} from '../../hooks/useSortOptionsSetttings'

interface DropdownItemProps {
  label: string
  itemSortBy: SortBy
}

const MAP_SORT_ORDER_TO_LABEL: Record<SortBy, Record<SortOrder, string>> = {
  'created-at': {
    asc: 'Show Older First',
    desc: 'Show Newer First',
  },
  'last-modified': {
    asc: 'Show Older First',
    desc: 'Show Newer First',
  },
  name: {
    asc: 'Order by A-Z',
    desc: 'Order by Z-A',
  },
}

const DropdownItem: React.FCC<DropdownItemProps> = ({ label, itemSortBy }) => {
  const { sortBy, sortOrder } = useSortingSettings()
  const setSort = useSetSortingSettings()

  const selected = sortBy === itemSortBy

  const handleClick = useCallback(() => {
    if (selected) {
      setSort({
        sortOrder: sortOrder === 'asc' ? 'desc' : 'asc',
      })
    } else {
      setSort({
        sortBy: itemSortBy,
      })
    }
  }, [itemSortBy, selected, setSort, sortOrder])

  return (
    <StyledDropdownItem
      className={selected ? 'active' : ''}
      onClick={handleClick}
    >
      <div>{label}</div>
      {selected && (
        <ArrowContainerTooltip
          content={MAP_SORT_ORDER_TO_LABEL[sortBy][sortOrder]}
          placement="top"
        >
          {sortOrder === 'asc' ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </ArrowContainerTooltip>
      )}
    </StyledDropdownItem>
  )
}

const LABEL_PER_OPTION: Record<SortOptions, string> = {
  name: 'Name',
  'created-at': 'Date created',
  'last-modified': 'Last updated',
}

export const SortDropdown: React.FC = () => {
  const sortOptions = useSortOptionsSettings()

  return (
    <>
      <Dropdown.Header>Sort By</Dropdown.Header>
      {sortOptions.map(option => (
        <DropdownItem
          key={option}
          label={LABEL_PER_OPTION[option]}
          itemSortBy={option}
        />
      ))}
    </>
  )
}
